module.exports = "https://static.zego.com/_next/static/images/icon-info-mask-3e61701334c1f47bea86492af6e56373.svg";